<template>
  <input-select
    single
    v-model="parceiro"
    :search="pesquisaParceiro"
    :options="parceiros"
    placeHolder="Selecione"
    :disabled="disabled"
    :required="required"
    @input="emiteInput">
  </input-select>
</template>

<script>
export default {
  data () {
    return {
      parceiro: null,
      parceiroAnterior: null,
      parceiros: []
    }
  },
  props: {
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  methods: {
    clear () {
      this.parceiro = null
    },
    emiteInput (val) {
      if (val && this.parceiroAnterior != val) {
        this.$emit('input', val)
      }
      this.parceiroAnterior = val
    },
    carregaParceiros () {
      let th = this

      this.$api.Parceiros.GetAll()
        .then(function (data) {
          if (Array.isArray(data)) {
            let arrayParceiros = []
            data.forEach((item) => {
              arrayParceiros.push({
                value: item.codigo,
                text: item.nome.concat(
                  ' ',
                  '(CNPJ: ',
                  th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
                  ')'
                )
              })
            })
            th.parceiros = arrayParceiros
          }
        })
    }
  },
  created () {
    this.pesquisaParceiro = _.debounce(this.carregaParceiros, 300)
  },
  mounted () {
    this.carregaParceiros()
  }
}
</script>
